import React, { useState, useEffect } from "react";
import ThongTinDuyetTatToan from "../DuyetTatToan/ThongTinDuyetTatToan";
import ThongBaoChucNang from "./ThongBaoChucNang";
import TatToanChoDuyetApi from "service/tatToanChoDuyetApi";
export const BtnDuyetTatToan = ({ item , SearchDanhSach}) => {
    const initThucHien = {
        duocphep: false,
        thongbao: '',
        shopadmin: false,
    };
    const [thuhien, setThucHien] = useState(initThucHien);
    const [isModalVisible, setModalVisible] = useState(false);
    const setModalCamDoShow = () => {
        CheckThucHien();
    }
    const CheckThucHien = () => {
        TatToanChoDuyetApi.phanQuyenTatToanChoDuyetTheoChucNang("", 1, item.TatToanChoDuyetID).then((response) => {
            setThucHien({
                ...thuhien,
                duocphep: response.data.ThucHien,
                thongbao: response.data.Message,
                shopadmin: response.data.ShopAdmin,
            });
            setModalVisible(!isModalVisible);
        });
    }
    return (
        <>
            <a onClick={(e) => setModalCamDoShow()} href={() => false} className="blue btn-link" title="Duyệt tất toán">
                <img src="/app-assets/images/icon-duyet-v2.png" />
            </a>
            {isModalVisible && thuhien.duocphep && (
                <ThongTinDuyetTatToan
                    show={isModalVisible}
                    onHide={setModalCamDoShow}
                    item={item}
                    shopAdmin={thuhien.shopadmin}
                    SearchDanhSach= {SearchDanhSach}
                ></ThongTinDuyetTatToan>
            )}
            {isModalVisible && !thuhien.duocphep && (
                <ThongBaoChucNang
                    show={isModalVisible}
                    onHide={setModalCamDoShow}
                    item={thuhien}
                ></ThongBaoChucNang>
            )}
        </>
    );
};